import { StorefrontIcon } from '@phosphor-icons/react'

import { isInboundParcel } from '@/parcels/helpers/helpers'
import routes from '@/Router/routes.constants'

const getRelatedInformationItems = ({ parcel, t }) => {
  const isInbound = isInboundParcel(parcel)

  const items = [
    {
      icon: StorefrontIcon,
      label: t('Pedido'),
      linkText: parcel?.order?.name,
      linkUrl: parcel?.order?.external_url,
      date: parcel?.order?.created_at,
    },
    {
      icon: StorefrontIcon,
      label: t('Transacción'),
      linkText: parcel?.related?.reference_number,
      linkUrl: isInbound && parcel?.related?.id ? routes.transactionDetailPage.replace(':id', parcel.related.id) : null,
      date: parcel?.created_at,
    },
  ]

  return items.filter(item => item.linkUrl)
}

export { getRelatedInformationItems }
